import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[mwSelectFooter]' })
export class MwSelectFooterDirective {
  constructor(public template: TemplateRef<any>) {}
}
